import { Button, FilePicker, IconArrowLeft, IconDownload, IconEye, IconUpload, IconX, InlineNotification, Modal, ProgressIndicator, Select, IconCheckmark, IconInfo } from "@veneer/core";
import React, { useEffect, useState, useRef } from "react";
import ConnectAPI from "../../../services/api";
import Swal from "sweetalert2";
import { downloadFile } from "../../../services/FileDownloader/FileDownloader";
import { useTranslation } from "react-i18next";
import moment from "moment";

const UploadModal = (props) => {
    const { t, i18n } = useTranslation();
    const [priceListType, setPriceListType] = useState([]);
    const [endUserSpecialPrice, setEndUserSpecialPrice] = useState([]);
    const [validFromDate, setValidFromDate] = useState([]);
    const [showInstructions, setShowInstructions] = useState(false);
    const [modalTitle, setModalTitle] = useState(t('priceListUpload'));
    const [fileToUpload, setFileToUpload] = useState(null);
    const [fileName, setFileName] = useState(t('selectFile'));
    const [uploading, setUploading] = useState(false);
    const [endUsersList, setEndUsersList] = useState([]);
    const [validFromDatesList, setValidFromDatesList] = useState([]);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationDetails, setNotificationDetails] = useState({ title: '', type: '', description: '' });
    const [lastPublicationDate, setLastPublicationDate] = useState();
    const [requestOverWriteConfirmation, setRequestOverwriteConfirmation] = useState(false);
    const [requestConfirmationPressNew, setRequestConfirmationPressNew] = useState(false);
    const fileInputRef = useRef();
    const [requestContinueConfirmation, setRequestContinueConfirmation] = useState(false);
    const [continueConfirmation, setContinueConfirmation] = useState(false);
    const [msgArrayList, setMsgArrayList] = useState([]);
    const [msgPressId, setMsgPressId] = useState("");

    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const connectApi = new ConnectAPI();

    const clearForm = () => {
        setPriceListType([]);
        setEndUserSpecialPrice([]);
        setValidFromDate([]);
        setFileToUpload(null);
        setFileName(t('selectFile'));
        setShowNotification(false);
        setModalTitle(t('priceListUpload'));

        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }

        const currentDate = new Date();
        let nextPublicationDate = new Date(moment(currentDate).format("YYYY-MM-DD"));
        let nextPublicationPlusOneMonth = new Date(moment(currentDate).add(1,"months").format("YYYY-MM-DD"));

        let dates = [];
        dates.push({ value: nextPublicationDate.getFullYear() + '-' + (nextPublicationDate.getMonth() + 1).toString().padStart(2, '0') + '-01', label: t('month' + (nextPublicationDate.getMonth() + 1).toString()) + ' ' + nextPublicationDate.getFullYear() });
        dates.push({ value: nextPublicationPlusOneMonth.getFullYear() + '-' + (nextPublicationPlusOneMonth.getMonth() + 1).toString().padStart(2, '0') + '-01', label: t('month' + (nextPublicationPlusOneMonth.getMonth() + 1).toString()) + ' ' + nextPublicationPlusOneMonth.getFullYear() });

        //console.log(dates);
        setValidFromDatesList(dates);
    }

    //clear form
    useEffect(clearForm, [props.showUploadPricingListModal]);

    useEffect(() => {
        if (currentUser.idRole == 9 || currentUser.idRole == 10) {

            const loadUploadPriceListModalData = (status, data) => {
                setEndUsersList(data.endUsers.map(item => {
                    return { value: item.idEndUser, label: item.endUserName.toUpperCase() };
                }));

                setLastPublicationDate(data.lastPublication);
            }

            connectApi
                .get(
                    "api/Channels/getPriceListUpdateData",
                    {
                        params: null,
                    },
                    loadUploadPriceListModalData
                )
                .catch((error) => {
                    Swal.fire(
                        "Error " + error.response.status,
                        error.response.data,
                        "error"
                    );
                });
        }
    }, []);

    const handleFilePickerChange = (e) => {
        setShowNotification(false);
        if (e.currentTarget.files.length > 0) {
            setFileToUpload(e.currentTarget.files[0]);
            setFileName(e.currentTarget.files[0].name);
        } else {
            setFileToUpload(null);
            setFileName(t('selectFile'));
        }
    }

    const handleSeeInstructionsClick = () => {
        setShowInstructions(true);
        setModalTitle(t('fillOutInstructions'))
    }

    const handleTemplateDownloadClick = () => {
        const fileName = priceListType[0] == 0 ? "StandardPricingListTemplate.xlsx" : "SpecialPricingListTemplate.xlsx";
        downloadFile(fileName);
    }

    const handleUploadClick = () => {
        uploadPriceList(false, false);
    }

    function getErrorList(data) {
        const desc = data.map(x => {
            return (
                <p>
                    <strong>{x.partNumber}: </strong>
                    {t(x.errorDescription)}
                </p>
            );
        });

        return desc;
    }
    function getErrorListTypes(data) {
        const rt = [];
        data.forEach(x => {
            var msj = "";
            switch (x){
                case "1": msj = "INK BLACK"; break;
                case "2": msj = "INK CYAN"; break;
                case "3": msj = "INK MAGENTA"; break;
                case "4": msj = "INK YELLOW"; break;
                case "5": msj = "INK SPECIAL"; break;
                case "6": msj = "PIP"; break;
                case "7": msj = "BLANKET"; break;
                case "8": msj = "BID"; break;
                case "9": msj = "BID ROLLER"; break;
                case "10": msj = "OMP"; break;
            }
            rt.push(<p> {t('missingConsumableType')}: <strong> {msj} </strong> </p>);
        });
        
        rt.push(<p> {t('pressid')}: <strong> {msgPressId} </strong> </p>);

        return rt;
    }

    function uploadPriceList(overwriteConfirmation, constinueConfirmation) {
        setUploading(true);

        let data = new FormData();
        data.append("priceListType", priceListType[0]);
        data.append("idEndUser", endUserSpecialPrice[0]);
        data.append("validFromDate", validFromDate[0]);
        data.append("file", fileToUpload);
        data.append("overwriteConfirmation", overwriteConfirmation)
        data.append("continueConfirmation", constinueConfirmation);

        const handleUploadPricingListResponse = (status, response) => {
            let clearFile = true;

            setUploading(false);
            if (typeof response == 'object') { //error table
                clearFile = true;
                setNotificationDetails({
                    title: t('issuesWithPartNumbersMessage'),
                    type: 'negative',
                    description: <><br />{getErrorList(response)}</>
                });
            }
            else if (response == 'allGood') {
                clearFile = true;
                setNotificationDetails({
                    title: t('priceListSuccessfullyUpdated'),
                    type: 'positive',
                    description: ''
                });
                props.fetchData();
            } else if (response == "wrongTemplate") {
                clearFile = true;
                setNotificationDetails({
                    title: t('priceListCouldNotBeUpdated'),
                    type: 'warning',
                    description: t('wrongTemplateDescriptionA') + (priceListType[0] == 0 ? t('channel') : t('endUser')) + t('wrongTemplateDescriptionB')
                });
            } else if (response == "emptyPriceList") {
                clearFile = true;
                setNotificationDetails({
                    title: t('priceListCouldNotBeUpdated'),
                    type: 'warning',
                    description: t('emptyPriceListDescription')
                });
            } else if (typeof response == 'string' && (response.startsWith('invalidValue') || response.startsWith('emptyValue'))) {
                clearFile = true;
                const invalidCell = response.split(':')[1];
                setNotificationDetails({
                    title: t('priceListCouldNotBeUpdated'),
                    type: 'warning',
                    description: t('invalidValueDescriptionA') + invalidCell + t('invalidValueDescriptionB')
                });
            } else if (typeof response == 'string' && response.startsWith('exceptionFromSP')) {
                clearFile = true;
                const msgFromSP = response.split(':')[1];
                setNotificationDetails({
                    title: t('priceListCouldNotBeUpdated'),
                    type: 'warning',
                    description: t(msgFromSP)
                });
            } else if (response == "invalidFileFormat" || response == "noEndUserProvided" || response == "invalidFromDate") {
                clearFile = true;
                setNotificationDetails({
                    title: t('inputCorrupted'),
                    type: 'negative',
                    description: ''
                });
            } else if (response == "exceptionFromNewPress") {
                clearFile = false;
                //ask if the list new Press
                setRequestConfirmationPressNew(true);
                setRequestOverwriteConfirmation(true);
            } else if (response == "userAcknowledgeRequired") {
                clearFile = false;
                //ask if the list must be overwriten
                setRequestOverwriteConfirmation(true);
            //respuesta en caso de algun Error/Warning en SpeciaList.
            } else if ( typeof response == 'string' && response.includes("ListError") ) {
                clearFile = false;
                const msgFromSP = response.split(':')[1];
                setMsgPressId(response.split(':')[2]);
                setMsgArrayList(msgFromSP.split(''));
                setRequestContinueConfirmation(true);
            }

            if (clearFile) {
                setFileToUpload(null);
                setFileName(t('selectFile'));
                fileInputRef.current.value = null;
                setShowNotification(true);
            }
        }

        connectApi
            .post(
                "api/Channels/UploadPricingList",
                data,
                handleUploadPricingListResponse
            )
            .catch((error) => {
                setUploading(false);
                props.setShowUploadPricingListModal(false);
                Swal.fire(
                    "Error " + error.response.status,
                    error.response.data,
                    "error"
                );
            });
    }

    const handleYesOverwriteConfirmation = () => {
        uploadPriceList(true, continueConfirmation);
        setRequestOverwriteConfirmation(false);
    }

    const handleNoOverwriteConfirmation = () => {
        setRequestOverwriteConfirmation(false);
        setFileToUpload(null);
        setFileName(t('selectFile'));
        fileInputRef.current.value = null;
    }
    const handleYesContinueConfirmation = () => {
        setContinueConfirmation(true);
        uploadPriceList(false, true);
        setRequestContinueConfirmation(false);
    }
    const handleNocontinueConfirmation = () => {
        setContinueConfirmation(false);
        setRequestContinueConfirmation(false);
        setFileToUpload(null);
        setFileName(t('selectFile'));
        fileInputRef.current.value = null;
    }

    return (
        <Modal
            id="upload-pricing-list-modal"
            show={props.showUploadPricingListModal}
            title={modalTitle}
            closeOnBlur={false}
            closeButton={true}
            onClose={() => props.setShowUploadPricingListModal(false)}
            footer={showInstructions ? (
                <div className="vn-button-group--responsive">
                    <Button leadingIcon={<IconArrowLeft />} onClick={() => { setShowInstructions(false); setModalTitle(t('priceListUpload')); }} appearance="secondary">
                        {t('backToUpload')}
                    </Button>
                </div>
            ) : (
                <div className="vn-button-group--responsive">
                    <Button leadingIcon={<IconUpload />} disabled={fileToUpload == null || requestOverWriteConfirmation} onClick={handleUploadClick} loading={uploading}>{t('upload')}</Button>
                    {/* <Button leadingIcon={<IconX />} onClick={() => props.setShowUploadPricingListModal(false)} appearance="secondary" loading={uploading}>{t('cancel')}</Button> */}
                </div>
            )}
        >
            <div className="show-animated" style={{ minHeight: '515px', display: showInstructions ? 'none' : 'block' }}>
                {uploading ? (<ProgressIndicator appearance="linear" />) : undefined}
                <label>{t('priceListType')}</label>
                <Select
                    placeholder={t('selectOption')}
                    options={[{ value: 0, label: t('channelPrices') }, { value: 1, label: t('specialPrices') }]}
                    onClear={() => {
                        setPriceListType([]);
                        setEndUserSpecialPrice([]);
                        setValidFromDate([]);
                        setFileToUpload(null);
                        setFileName(t('selectFile'));
                    }}
                    onChange={(e) => {
                        setPriceListType([e.value]);
                        setValidFromDate([]);
                        setEndUserSpecialPrice([]);
                        setFileToUpload(null);
                        setFileName(t('selectFile'));
                    }}
                    value={priceListType}
                    disabled={requestOverWriteConfirmation}
                />
                {priceListType[0] == 1 ? (
                    <>
                        <label className="show-animated">{t('endUser')}</label>
                        <Select
                            className="show-animated"
                            placeholder={t('selectEndUser')}
                            options={endUsersList}
                            onClear={() => setEndUserSpecialPrice([])}
                            onChange={(e) => setEndUserSpecialPrice([e.value])}
                            value={endUserSpecialPrice}
                            disabled={requestOverWriteConfirmation}
                        />
                    </>
                ) : undefined}
                <label style={{ opacity: (priceListType.length == 0 || (priceListType[0] == 1 && endUserSpecialPrice.length == 0)) ? '.4' : '1' }}>{t('pricingListValidFrom')}</label>
                <Select
                    placeholder={t('selectDate')}
                    options={validFromDatesList}
                    onClear={() => setValidFromDate([])}
                    onChange={(e) => setValidFromDate([e.value])}
                    value={validFromDate}
                    disabled={priceListType.length == 0 || (priceListType[0] == 1 && endUserSpecialPrice.length == 0) || requestOverWriteConfirmation}
                />
                <label style={{ opacity: (validFromDate.length == 0 ? '.4' : '1'), display: 'block' }}>{t('file')}</label>

                <div id="file-picker-container">
                    <label
                        id="custom-file-input"
                        htmlFor="file-input-price-list"
                        is-disabled={validFromDate.length == 0 || requestOverWriteConfirmation ? 'true' : 'false'}
                        onClick={(e) => {
                            if (validFromDate.length == 0 || requestOverWriteConfirmation) e.preventDefault();
                        }}

                    >
                        {fileName}
                    </label>
                    <span is-disabled={validFromDate.length == 0 || requestOverWriteConfirmation ? 'true' : 'false'}><IconUpload /></span>
                </div>
                <input
                    id="file-input-price-list"
                    type="file"
                    style={{ display: 'none' }}
                    accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                    onChange={handleFilePickerChange}
                    ref={fileInputRef}
                />

                {priceListType.length > 0 ? (
                    <div className="custom-alert show-animated">

                        <p>{t('priceListUploadModalHelpText1')}</p>
                        <Button appearance="secondary" leadingIcon={<IconDownload />} onClick={handleTemplateDownloadClick}>
                            {t('downloadTemplate')}
                        </Button>

                        <p style={{ marginTop: '16px' }}>{t('priceListUploadModalHelpText2')}</p>
                        <Button small={true} appearance="secondary" leadingIcon={<IconEye />} onClick={handleSeeInstructionsClick}>
                            {t('seeFillOutInstructions')}
                        </Button>
                    </div>
                ) : undefined}
                {showNotification ? (
                    <div className="show-animated" style={{ marginTop: '28px', marginBottom: '-16px' }}>
                        <InlineNotification
                            title={notificationDetails.title}
                            type={notificationDetails.type}
                            description={notificationDetails.description}
                            onClose={() => { setShowNotification(false) }}
                        />
                    </div>
                ) : undefined}
                {requestOverWriteConfirmation ? (
                    <div className="custom-alert show-animated">
                        {/* <div style={{ textAlign: 'center' }}><IconInfo size={100} /></div> */}
                        <p><IconInfo style={{ width: '25px' }} size={25} color="colorRed4" />
                        { requestConfirmationPressNew ? t('overwritePressConfirmation') : t('overwritePricesConfirmation') }</p>
                        <Button
                            appearance="primary"
                            leadingIcon={<IconCheckmark />}
                            onClick={handleYesOverwriteConfirmation}
                        >
                            {t('Yes')}
                        </Button>
                        <Button
                            appearance="secondary"
                            leadingIcon={<IconX />}
                            onClick={handleNoOverwriteConfirmation}
                            style={{ marginLeft: '8px' }}
                        >
                            {t('No')}
                        </Button>
                    </div>
                ) : undefined}
                {requestContinueConfirmation ? (
                    <div className="custom-alert show-animated">
                        {/* <div style={{ textAlign: 'center' }}><IconInfo size={100} /></div> */}
                        <p><IconInfo style={{ width: '25px' }} size={25} color="colorRed4" /> {t('warning')} </p>
                        {getErrorListTypes(msgArrayList)}
                        <p><strong> {t('continueWhitProcess')} </strong></p>
                        <p>{t('overwriteContinueConfirmation')}</p>
                        <Button
                            appearance="primary"
                            leadingIcon={<IconCheckmark />}
                            onClick={handleYesContinueConfirmation}
                        >
                            {t('Yes')}
                        </Button>
                        <Button
                            appearance="secondary"
                            leadingIcon={<IconX />}
                            onClick={handleNocontinueConfirmation}
                            style={{ marginLeft: '8px' }}
                        >
                            {t('No')}
                        </Button>
                    </div>
                ) : undefined}
            </div>
            <div className="show-animated" style={{ minHeight: '515px', display: showInstructions ? 'block' : 'none' }}>
                <ul>
                    <li style={{ fontStyle: 'italic' }}>{priceListType[0] == 0 ? t('channelInstructionsLine0') : t('endUserInstructionsLine0')}</li>
                    <li>{priceListType[0] == 0 ? t('channelInstructionsLine1') : t('endUserInstructionsLine1')}</li>
                    <li>{t('instructionsLine2')}</li>
                    <li>{t('instructionsLine3')}</li>
                    <li>{t('instructionsLine4')}</li>
                    <li>{t('instructionsLine5')}</li>
                </ul>
                <br />
                <p><strong>{t('instructionsNote')}</strong></p>
                <br />
                <p><strong>{priceListType[0] == 0 ? t('channelWarningInstructions') : t('endUserWarningInstructions')}</strong></p>
                <br />
                <p>{t('asistanceInstructions')} <a href="mailto:ipsp@hp.com">ipsp@hp.com</a></p>
            </div>
        </Modal>
    );
}

export default UploadModal;
